export default {"src":"/_next/static/media/search-icon.3f24cb66.svg","height":80,"width":80,"blurWidth":0,"blurHeight":0};